import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';

import type { KpiCard as KpiCardData } from '@control-center/shared';

interface KpiCardProps {
  label: string;
  card: KpiCardData;
  subtitle?: string;
  formatter?: (value: number) => string;
}

const brl = (v: number): string =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });

/**
 * Story 6.1 AC3/AC4 — Card de KPI usando tokens design system (CSS vars).
 * Respeita dark theme via :root vs .dark.
 */
export function KpiCard({ label, card, subtitle, formatter = brl }: KpiCardProps) {
  const trendColor =
    card.trend === 'up' ? 'text-good' : card.trend === 'down' ? 'text-bad' : 'text-muted-2';

  const trendIcon =
    card.trend === 'up' ? (
      <ArrowUpRight className="h-3.5 w-3.5" />
    ) : card.trend === 'down' ? (
      <ArrowDownRight className="h-3.5 w-3.5" />
    ) : (
      <Minus className="h-3.5 w-3.5" />
    );

  const deltaLabel =
    card.delta_pct === null
      ? '—'
      : `${card.delta_pct >= 0 ? '+' : ''}${card.delta_pct.toFixed(1)}%`;

  return (
    <div className="rounded-lg border border-line bg-panel p-4">
      <div className="text-xs font-medium text-muted">{label}</div>
      <div className="mt-2 font-mono text-[32px] leading-none tracking-tight text-ink tabular-nums">
        {formatter(card.value)}
      </div>
      <div className={`mt-3 flex items-center gap-1 text-xs font-medium ${trendColor}`}>
        {trendIcon}
        <span>{deltaLabel}</span>
        {subtitle && <span className="ml-1 text-muted-3">{subtitle}</span>}
      </div>
    </div>
  );
}

export function KpiCardCount({
  label,
  value,
  subtitle,
}: {
  label: string;
  value: number;
  subtitle?: string;
}) {
  return (
    <div className="rounded-lg border border-line bg-panel p-4">
      <div className="text-xs font-medium text-muted">{label}</div>
      <div className="mt-2 font-mono text-[32px] leading-none tracking-tight text-ink tabular-nums">
        {value.toLocaleString('pt-BR')}
      </div>
      {subtitle && <div className="mt-3 text-xs text-muted-3">{subtitle}</div>}
    </div>
  );
}
